export default "__VITE_ASSET__dcda35c9__"